// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./projectJoinButton.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("ab2bd604", content, true, {});